import { useQuery } from '@tanstack/react-query';

type GeoResponse = { country: string | null };

// Lightweight hook over `/api/geo`. The result is cached for the
// session (staleTime: Infinity) since a visitor's country is unlikely
// to change while they're browsing.
export function useGeo() {
  return useQuery<GeoResponse>({
    queryKey: ['/api/geo'],
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
}
